import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useInventoryContext } from '../contexts/InventoryContext';
import { formatARS } from '../utils/format';
import { inputClass } from './FormField';
interface VehicleSelectProps {
  id: string;
  value: string;
  onChange: (id: string) => void;
  placeholder: string;
}
export function VehicleSelect({
  id,
  value,
  onChange,
  placeholder
}: VehicleSelectProps) {
  const {
    cars
  } = useInventoryContext();
  return <div className="relative" data-id="element-404" data-mp="ybod29r5r5ie">
      <select id={id} value={value} onChange={e => onChange(e.target.value)} className={`${inputClass} appearance-none pr-9`} data-id="element-405" data-mp="ybewtdvx0cpw">
        <option value="" data-id="element-406" data-mp="uammehbb41s1">{placeholder}</option>
        {cars.map(car => <option key={car.id} value={car.id} data-id="element-407" data-mp="pc1nqmbpdq5p">
            {car.brand} {car.model} {car.version} {car.year} · {formatARS(car.cashPrice)}
          </option>)}
      </select>
      <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-408" data-mp="2johqve97co6c" />
    </div>;
}